import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';

export interface ColumnDefinition {
  key: string,
  label: string,
  type: string
}

interface ColumnSelectorDialogData {
  allColumns: ColumnDefinition[];
  selected: string[];
  defaultSelection: string[];
  defaultOrder: string[];
}

@Component({
  selector: 'column-selector-dialog',
  imports: [
    MatSelectModule,
    MatListModule,
    CommonModule,
    MatDialogModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    DragDropModule
  ],
  templateUrl: './column-selector-dialog.component.html',
  styleUrl: './column-selector-dialog.component.scss'
})
export class ColumnSelectorDialogComponent {
  defaultSelection: string[];
  selected: string[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: ColumnSelectorDialogData) {
    this.defaultSelection = data.defaultSelection;
    this.selected = data.selected;
  }

  drop(event: CdkDragDrop<any[]>) {
    // Update allColumns
    moveItemInArray(
      this.data.allColumns,
      event.previousIndex,
      event.currentIndex
    );

    // reorder selected columns according to order of allColumns
    const selectedSet = new Set(this.selected);
    this.selected = this.data.allColumns
      .map(c => c.key)
      .filter(key => selectedSet.has(key));
  }

  reset() {
    const orderMap = new Map(
      this.data.defaultOrder.map((key, index) => [key, index])
    );

    this.data.allColumns = [...this.data.allColumns].sort((a, b) => {
      return (orderMap.get(a.key) ?? Number.MAX_SAFE_INTEGER) -
        (orderMap.get(b.key) ?? Number.MAX_SAFE_INTEGER);
    });

    this.selected = this.defaultSelection;
  }
}
